import './scripts/main';
import './scripts/share';
import './scripts/forms';
import { createSwiper } from './scripts/swipers';
import { setupPageLoadCallback, isTablet } from './scripts/utils';

setupPageLoadCallback(() => {
  $('.swiper-container').each(function () {
    createSwiper(this, {
      loop: true,
      pagination: this.classList.contains('swiper-fullscreen') ? {
        el: '.swiper-pagination',
        clickable: true,
      } : {},
      navigation: {
        nextEl: '.swiper-control-next',
        prevEl: '.swiper-control-prev',
      },
      spaceBetween: this.classList.contains('swiper-fullscreen') ? 0 : isTablet() ? 20 : 80,
    });
  });
});

function toggleVideo(video) {
  if (video.paused) {
    video.play();
  } else {
    video.pause();
  }

  $(video).siblings('.player-controls').toggleClass('paused');
}

$('.video-player .play').on('click', function() {
  const video = $(this).parent().siblings('video')[0];
  if (!video) {
    return;
  }
  toggleVideo(video);
})

$('.video-player video').on('click', function() {
  toggleVideo(this);
});
